import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

export function getB2CMsalInstance(msalConfig): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: msalConfig.frontendClientId,
      authority: msalConfig.policies.signInPhone.authority,
      knownAuthorities: [`${msalConfig.tenant}.b2clogin.com`],
      redirectUri: '/login-callback',
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowRedirectInIframe: !!msalConfig.allowRedirectInIframe,
    },
  });
}

export function getB2CMsalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function getB2CMsalInterceptorConfig(
  msalConfig,
  resource?: string,
  extraEndpoints?: { url: string; clientId: string }[],
  unprotectedEndpoints?: string[],
): MsalInterceptorConfiguration {
  let endpoint = msalConfig.apiResource;
  if (resource) {
    endpoint += resource;
  }

  const resourceMap = new Map();

  if (unprotectedEndpoints) {
    for (const unprotectedEndpoint of unprotectedEndpoints) {
      // eslint-disable-next-line unicorn/no-null
      resourceMap.set(unprotectedEndpoint, null);
    }
  }

  resourceMap.set(endpoint, [
    `https://${msalConfig.tenant}.onmicrosoft.com/${msalConfig.backendClientId}/all`,
  ]);

  if (extraEndpoints) {
    for (const extraEndpoint of extraEndpoints) {
      resourceMap.set(extraEndpoint.url, [
        `https://${msalConfig.tenant}.onmicrosoft.com/${extraEndpoint.clientId}/all`,
      ]);
    }
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: resourceMap,
  };
}

export function GetMsalInterceptorConfiguration(
  interceptorConfig: MsalInterceptorConfiguration,
  b2cMsalConfig,
): MsalInterceptorConfiguration {
  return {
    interactionType: interceptorConfig.interactionType,
    protectedResourceMap: interceptorConfig.protectedResourceMap,
    authRequest: (msalService, _httpReq, originalAuthRequest) => {
      return {
        ...originalAuthRequest,
        authority: `https://${b2cMsalConfig.tenant}.b2clogin.com/${
          b2cMsalConfig.tenant
        }.onmicrosoft.com/${
          msalService.instance.getActiveAccount()?.idTokenClaims['tfp'] ??
          b2cMsalConfig.policies.signInPhone.name
        }`,
      };
    },
  };
}
